// Module
var code = `<div class="tuition-ledger"><div class="ledger-row {{row.className}}" ng-repeat="row in tuitionLedgerRows"><div class="title-and-cost-or-discount"><div class="title" ng-bind-html="::row.titleLocale"></div><div class="cost-or-discount" ng-bind-html="::row.costOrDiscountLocale"></div></div></div></div>`;
// Exports
export default code;